const styleStringToObj = styleString => {
    return styleString.split(';').reduce((acc, style) => {
        const [key, value] = style.split(':');
        if (value) acc[key] = value;
        return acc;
    }, {});
};

export default styleStringToObj;
